var _jsxFileName = "/codebuild/output/src3324576443/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/VerifyNumber/components/Content.tsx";
import React from 'react';
import { Button, LinkText, Stack, Text } from '@adc/parallax-component-library';
import parsePhoneNumber from 'libphonenumber-js';
import { OTPInput } from 'Components/utility/OTPInput';
import { formatMobileNumber } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
const Content = ({
  onButtonPress,
  onClickEditBtn,
  disableEditBtn,
  formikForm
}) => {
  const {
    values,
    errors,
    touched,
    handleChange
  } = formikForm;
  const phoneNum = values.mobileNumber;
  if (!phoneNum) {
    return null;
  }
  const parsedPhoneNumber = parsePhoneNumber(phoneNum);
  const formattedMobileNumber = formatMobileNumber(parsedPhoneNumber);
  return /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    marginTop: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "VerifyMobileNumber.subtitle",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 9
    }
  }, i18n.t('VerifyMobileNumber.subtitle')), /*#__PURE__*/React.createElement(Stack, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "$text.100",
    fontWeight: "$bodyBase.strong",
    fontSize: "$bodyBase.strong",
    testID: "VerifyMobileNumber.mobileNumber",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 11
    }
  }, formattedMobileNumber), !disableEditBtn && /*#__PURE__*/React.createElement(LinkText, {
    href: "",
    marginLeft: "$2",
    type: "$bodyBase.default",
    "aria-label": i18n.t('Global.microcopy.common.edit'),
    onPress: onClickEditBtn,
    testID: "VerifyMobileNumber.edit-btn",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 13
    }
  }, i18n.t('Global.microcopy.common.edit'))), /*#__PURE__*/React.createElement(Text, {
    testID: "VerifyMobileNumber.primaryText",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  }, i18n.t('VerifyMobileNumber.content.enterCode.primaryText', {
    min: 10
  }))), /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      placeItems: 'center'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(OTPInput, {
    "aria-label": "otp input",
    label: "",
    isInvalid: Boolean(errors.otp) && touched.otp,
    errorMessage: errors.otp,
    value: values.otp,
    length: 6,
    onValueChange: handleChange('otp'),
    testID: "otp",
    width: "100%",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Stack, {
    gap: "$2",
    marginTop: "$8",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "center",
    testID: "VerifyMobileNumber.bodyText",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 9
    }
  }, i18n.t('VerifyMobileNumber.content.enterCode.bodyText')), /*#__PURE__*/React.createElement(Stack, {
    justifyContent: "center",
    gap: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    label: i18n.t('VerifyMobileNumber.content.enterCode.links.resendCode.label'),
    "aria-label": i18n.t('VerifyMobileNumber.content.enterCode.links.resendCode.label'),
    onPress: onButtonPress,
    testID: "VerifyMobileNumber.resendEmail-btn",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 11
    }
  }))));
};
export default Content;